import { processInfoRequest, getDirectionName } from '@/network/requests/processInfo'
import { processGroupRequest } from '@/network/requests/processGroup'
import { processGroupDetailRequest } from '@/network/requests/processGroupDetail'
import List from './List2'
export default {
	components: {
		List,
	},
	data() {
		/**
		 * 工序组重名检查。
		 * @param {*} rule
		 * @param {*} value
		 * @param {*} callback
		 */
		var validateProcessGroupNameExist = (rule, value, callback) => {
			if (!value) {
				callback(new Error('请输入工艺参数组名称'))
			} else {
				var msg = '工序参数组名称已经存在，请更换名称。'
				//检查名称是否重复。
				processGroupRequest.queryAll({ name: value }).then(res => {
					if (res.length > 1) {
						callback(new Error(msg))
					} else if (res.length == 1) {
						var data = res[0]

						if (this.form._id) {
							if (data._id.$oid != this.form._id.$oid) {
								callback(new Error(msg))
							} else {
								callback()
							}
						} else {
							callback(new Error(msg))
						}
					} else {
						callback()
					}
				})
			}
		}

		return {
			pageSize: 10,
			pageIndex: 1,
			pageCount: 1,
			nameSearch: '',
			tableData: [],
			dialogTitle: '',
			dialogVisible: false,
			dialog: '',
			form: {
				detials: [],
			},
			formRules: {
				name: [{ validator: validateProcessGroupNameExist, trigger: 'blur' }],
			},
			modifying: false,
			tableLoading: false,
			/**
			 * 当前工序组的工序详情。
			 */
			details: [],
			detailsConfigDialogVisible: false,
			currentGroup: '',
			processList: [],
			/**
			 * 所有工序详情。
			 */
			processDetails: [],
		}
	},
	methods: {
		/**
		 * 查询工序组。
		 */
		query() {
			processGroupRequest
				.searchPage(this.pageSize, this.pageIndex, { name: this.nameSearch })
				.then(res => {
					this.pageCount = res.data._total_pages

					var array = []
					res.data._embedded.forEach((v, i) => {
						var details = this.processDetails.filter(t => t.process_group_id == v._id.$oid).sort((a, b) => a.sequence - b.sequence)

						console.log('details', details)

						array.push({ ...v, detials: details })
					})

					this.tableData = array
				})
				.finally(() => {
					this.tableLoading = false
				})
		},
		/**
		 * 加载工序详情。
		 */
		loadProcessDetails(groupId) {
			var res = this.processDetails.filter(t => t.process_group_id == groupId)

			var array = []
			res.forEach((v, i) => {
				var p = this.processList.find(p => p._id.$oid == v.process_id)
				if (!p) {
					p = {}
				}

				array.push({ ...v, process: p })
			})

			this.details = array
			this.detailsConfigDialogVisible = true
		},
		/**
		 * 更新表格。
		 */
		updateTableData(groupId) {
			//重新加载工序组的工序。
			this.loadProcessDetails(groupId)

			//更新工序组的显示数组。
			var tableDataIndex = this.tableData.findIndex(t => t._id.$oid == groupId)
			var td = this.tableData[tableDataIndex]
			td.detials = this.processDetails.filter(t => t.process_group_id == groupId)
			this.tableData.splice(tableDataIndex, 1, td)
		},
		/**
		 * 切换页码。
		 */
		handleCurrentChange(page) {
			this.tableLoading = true
			this.pageIndex = page
			this.query()
		},
		/**
		 * 切换每页记录数量。
		 */
		handleSizeChange(size) {
			this.tableLoading = true
			this.pageIndex = 1
			this.pageSize = size
			this.query()
		},
		/**
		 * 添加工序组。
		 */
		handleAdd() {
			this.dialogTitle = '添加工序组'
			this.form = {
				detials: [],
			}
			this.dialogVisible = true
			this.dialog = 'edit'
		},
		/**
		 * 关闭工序组编辑弹出窗。
		 */
		handleDialogCancel() {
			this.dialogVisible = false
		},
		/**
		 * 工序参数组表单验证。
		 * @param {*} callback
		 */
		groupFormValidate(callback) {
			this.$refs['processGroupForm'].validate(callback)
		},
		/**
		 * 保存工序组。
		 */
		handleSubmit() {
			if (this.modifying) {
				return
			} else {
				this.modifying = true
			}
			this.groupFormValidate(valid => {
				if (valid) {
					processGroupRequest
						.upload(this.form)
						.then(res => {
							console.log('工序组添加完成', res)
						})
						.finally(() => {
							this.dialogVisible = false

							setTimeout(() => {
								this.modifying = false
							}, 1000)

							this.pageIndex = 1
							this.query()
						})
				} else {
					this.modifying = false
				}
			})
		},
		/**
		 * 删除工序组。
		 */
		handleDelete(row) {
			var id = row._id.$oid

			//1、删除工序组信息。
			processGroupRequest.deleteById(id).then(res => {
				//2、删除工序组详情。
				processGroupDetailRequest.deleteBatch({ tech_group_id: id }).finally(() => {
					this.query()
				})
			})
		},
		/**
		 * 编辑工序组。
		 */
		handleEdit(row) {
			this.form = { ...row }
			this.dialogTitle = '编辑工序组'
			this.dialogVisible = true
			this.dialog = 'edit'
		},
		/**
		 * 配置工序组。
		 */
		handleConfig(row) {
			this.currentGroup = row
			this.loadProcessDetails(row._id.$oid)
		},
		/**
		 * 选中工序。
		 */
		handleSelect(obj) {
			var groupId = this.currentGroup._id.$oid

			//工序排序值。
			var sequence = 1
			if (this.details.length > 0) {
				var sequences = this.details.map(t => t.sequence)
				sequence = Math.max(...sequences) + 1

				console.log('工序排序值', sequence, sequences)
			}

			var form = {
				process_group_id: groupId,
				process_id: obj._id.$oid,
				sequence: sequence,
			}
			processGroupDetailRequest
				.upload(form)
				.then(res => {
					//更新工序详情的Id值。
					form._id = { $oid: res }
					//添加工序组选中信息。
					this.processDetails.push(form)
					this.details.push(form)
				})
				.finally(() => {
					form.process = obj

					//更新工序组的显示数组。
					this.updateTableData(groupId)
				})
		},
		/**
		 * 取消工序组中的工序。
		 */
		handleCancelSelect(obj) {
			var groupId = this.currentGroup._id.$oid
			processGroupDetailRequest.deleteBatch({ process_group_id: groupId, process_id: obj._id.$oid }).finally(() => {
				var index = this.processDetails.findIndex(t => t.process_group_id == groupId && t.process_id == obj._id.$oid)

				//删除工序组中的工序。
				this.processDetails.splice(index, 1)

				//更新工序组的显示数组。
				this.updateTableData(groupId)
			})
		},
		/**
		 * 获取工序方向。
		 */
		getDirectionNameByValue(id) {
			return getDirectionName(id)
		},
		/**
		 * 删除工序。
		 */
		deleteProcess(row) {
			this.tableLoading = true
			var processId = row._id.$oid
			processInfoRequest.deleteById(processId).then(res => {
				//删除工序组中的所有相关工序。
				processGroupDetailRequest
					.deleteBatch({ process_id: processId })
					.then(res => {
						console.log('删除工序组中的所有关联工序')
					})
					.finally(() => {
						this.loadData()
					})
			})
		},
		/**
		 * 工序保存成功。
		 */
		savedProcess() {
			this.loadData()
		},
		/**
		 * 加载工序数据。
		 */
		loadData() {
			processInfoRequest
				.queryAll()
				.then(res => {
					console.log('加载工序')
					this.processList = res
				})
				.then(() => {
					processGroupDetailRequest
						.queryAll()
						.then(res => {
							var array = []
							res.forEach((v, i) => {
								var p = this.processList.find(t => t._id.$oid == v.process_id)
								array.push({ ...v, process: p })
							})

							this.processDetails = array
						})
						.then(() => {
							this.query()
						})
				})
		},
		/**
		 * 修改工序的顺序。
		 */
		changeSort(row) {
			this.dialog = 'sort'
			this.form = row

			console.log('row', row)
		},
		saveSort() {
			this.form.detials.forEach((v, i) => {
				var obj = {
					process_group_id: v.process_group_id,
					process_id: v.process_id,
					sequence: v.sequence,
					_id: v._id,
				}
				processGroupDetailRequest.modifyById(v._id.$oid, obj)
			})

			this.dialog = ''
			this.tableLoading = true
			this.loadData()
		},
		/**
		 * 排序值下移。
		 * @param {*} param0
		 */
		sortDown({ row, column, $index }) {
			var data = this.form.detials

			var oldValue = row.sequence
			var newValue = data[$index + 1].sequence

			data[$index].sequence = newValue
			data[$index + 1].sequence = oldValue

			processGroupDetailRequest.modifyById(data[$index]._id.$oid, data[$index])
			processGroupDetailRequest.modifyById(data[$index + 1]._id.$oid, data[$index + 1])

			data.sort((a, b) => {
				return a.sequence - b.sequence
			})

			this.form.detials = data
		},
		/**
		 * 排序值上移。
		 * @param {*} param0
		 */
		sortUp({ row, column, $index }) {
			var data = this.form.detials
			var oldValue = row.sequence
			var newValue = data[$index - 1].sequence

			data[$index].sequence = newValue
			data[$index - 1].sequence = oldValue

			processGroupDetailRequest.modifyById(data[$index]._id.$oid, data[$index])
			processGroupDetailRequest.modifyById(data[$index - 1]._id.$oid, data[$index - 1])

			data.sort((a, b) => {
				return a.sequence - b.sequence
			})

			this.form.detials = data
		},
	},
	created() {
		this.tableLoading = true
		this.loadData()
	},
}
